import { render, staticRenderFns } from "./CountryRanks.vue?vue&type=template&id=1e5fc8e6&scoped=true&"
import script from "./CountryRanks.vue?vue&type=script&lang=js&"
export * from "./CountryRanks.vue?vue&type=script&lang=js&"
import style0 from "./CountryRanks.vue?vue&type=style&index=0&id=1e5fc8e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5fc8e6",
  null
  
)

export default component.exports